import { useNavigate } from "react-router-dom";
import { logout } from "../services/accountsService";
import { useAuth } from "../contexts/AuthContext";

export function useAccount() {
    const { user, loading, error, logout: logoutFromContext } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logout();
        } finally {
            // 認証コンテキストの状態をクリア
            logoutFromContext();
            // セッション認証ではlocalStorageのJWTトークンは使用しない
            navigate("/login", { replace: true });
        }
    };

    return {
        user,
        loading,
        error: error ? "ユーザー情報の取得に失敗しました。" : "",
        handleLogout,
    };
}